import { createContext, useContext } from "react";

export const KpiPopoverRowContext = createContext(null);

export function useKpiPopoverRow() {
  return useContext(KpiPopoverRowContext);
}